export default __webpack_public_path__ + "0334efc0de1012200889a409f0c659f4.woff2";